// extracted by mini-css-extract-plugin
export default {"efficiencyContent":"efficiency-content_efficiencyContent__FNxTD","title":"efficiency-content_title__kNqYD"};